import { HttpClient } from "@angular/common/http";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import _ from "lodash";
import { Subscription } from "rxjs/internal/Subscription";
import { ApiService } from "src/app/services/api.service";
import { DataService } from "src/app/services/data.service";
import { FilterService } from "src/app/services/filter.service";
import { NavigationService } from "src/app/services/navigation.service";
import { NewFilterService } from "src/app/services/new-filter.service";
import { UserActivityService } from "src/app/services/useractivity.service";

@Component({
  selector: 'app-scatter-plot-card',
  templateUrl: './scatter-plot-card.component.html',
  styleUrls: ['./scatter-plot-card.component.scss']
})
export class WidgetScatterPlotCardComponent implements OnInit {
  static key = 100814;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;

  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("ScatterPlotChartDiv", { static: true }) ScatterPlotChartDiv!: ElementRef;

  config: any;
  data: any;
  isDataLoaded = false;
  reqSubcription: Subscription[] = [];

  heatMapNoData: boolean = false;
  heatMapConfig: any={ };
  selectedValue='percent';

  selectedPoints: string = "";
  error_name:any;
  prefrenceConfig:any;
  dashboardKey:any

  constructor(
    private filterService: FilterService,
    private newFilterService: NewFilterService,
    private route: ActivatedRoute,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private userActivityService: UserActivityService,
    private navigationService: NavigationService,
    private dataService: DataService
  ) {
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.loadApiData();
      }),
      this.newFilterService.showBy.subscribe((value: any) => {
        this.loadApiData(value);
        
      })
    );
      this.route.queryParams.subscribe((params: any) => {
      let decryptedParams = this.navigationService.decryptData(params);
 
      this.dashboardKey = decryptedParams["ds_key"];
    
    });
   }


  ngOnInit(): void {
    this.item;

    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.ScatterPlotChartDiv.nativeElement);
    this.loadlineConfig();
  }

  loadlineConfig() {
    const cfg = this.item?.['config'] 

    // this.heatMapConfig['value'] = {
    //   XaxisVar: cfg['x_axis']['api_resp_column_nm'] ||  'period',
    //   YaxisVar: cfg['y_axis']['api_resp_column_nm'] ||  'source_name',
    //   valueVar: cfg['value_column']['api_resp_column_nm'] || "qty_difference"
    // }
    
    // this.heatMapConfig['percent'] = {
    //   XaxisVar: cfg['x_axis']['api_resp_column_nm'] || 'period',
    //   YaxisVar: cfg['y_axis']['api_resp_column_nm'] || 'source_name',
    //   valueVar: cfg['percentage_column']['api_resp_column_nm'] || "pct_difference"
    // }

    this.heatMapConfig = {
      "value": {
          "XaxisVar": "period",
          "YaxisVar": "source_name",
          "valueVar": "qty_difference"
      },
      "percent": {
          "XaxisVar": "period",
          "YaxisVar": "source_name",
          "valueVar": "pct_difference"
      }
  }
  }
  

  loadApiData(showby?: string) {
    // first get sources and kpi with lookback periods
    let api = this.item.config["list_of_api"] || {};
    if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
     this.getPreferences()
      interface scatterData {
        source_type: string;
        source_name: string;
        source_key: number;
        du_sp_location_name: string | null;
        du_sp_location_key: number;
        kpi_key: number;
        kpi_value: number;
        kpi_name: string;
        lower_threshold: number | null;
        upper_threshold: number | null;
        look_back_period: number;
        upper_control_limit: number;
        lower_control_limit: number;
        patient_volume: number;
        x_axis_value: string;
        periods: { period: string; kpi_value: number }[]; // Add a new field for periods
      }

      // fetch the properties of the brand (sources, KPIs, lookback periods)
      let obj:any = {"api_key": '999998',"report_typ" : 'D', "time_cycle" : this.filterService.report_type}
      let query =  Object.assign({}, this.filterService.baseQuery, obj)
      query['module_key'] = this.apiService.getModuleKey();
      let endPoint = this.item.config?.["list_of_api_endpoint"] || '';

      let maxLookBack = 0;
      let myData: scatterData[] = []
      let myProps: any[] = []
      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query).subscribe(
          (res: any) => {
            res.forEach((d: any) =>{
              // Add non location data for the time being
              // if (!d.du_sp_location_name){   // comment out this if to include location data
                // **** TODO:: API SHOULD ONLY RETURN SELECTED KPIs  ****
                console.log(this.filterService.baseQuery.kpi_key);
                // filter out unselected KPIs
                // if (this.filterService.baseQuery.kpi_key.split(',').includes(d.kpi_key.toString())){
                d.look_back_period > maxLookBack ? maxLookBack = d.look_back_period : maxLookBack; 
                myProps.push(d);
            });


            // REMOVE PATIENT VOLUME FETCH
            // second request to get patient volume for sources
            // can be run when just the first query is completed
            // let obj2:any = {"api_key": '100703',"report_typ" : 'D', "time_cycle" : this.filterService.report_type}
            // this.reqSubcription.push(
            //   this.filterService.kpiBreakdownQuery(obj2).subscribe(
            //     (res: any) => { 
            //       // Add patient volume to each source
            //       myProps.forEach(entry1 =>{
            //         // default patient volume to be 0
            //         entry1.patient_volume = 0;
            //         res.forEach((entry2: {source_name: string, total_patients: number}) =>{
            //           if(entry1.source_name == entry2["source_name"]){
            //             entry1.patient_volume = entry2["total_patients"]
            //           }
            //         })
            //       });

                  // need patient volume before running this request
                  // now activate third HTTP request to get previous periods DATA using maxLookBack
                  let obj1:any = {"api_key" : "999999" };
                  let query1 = Object.assign({}, this.filterService.baseQuery, obj1);

                  // Go back from_date according to max lookback period and time_cycle
                  query1["from_date"] = this.goBackCycles(query1["from_date"], maxLookBack, this.filterService.report_type);
                  // query1["to_date"] = "2024-12-31";
                  query1["source_key"] = null;

                  query1["report_typ"] = 'D';
                  query1["time_cycle"] = this.filterService.report_type;
                  query1['report_key']=undefined
                  this.reqSubcription.push(
                    this.httpClient.post(`${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`, query1).subscribe((res:any)=> {
                      let singleProp;
                      let matchingData;
                      res = _.sortBy(res, "period");
                      res.forEach((entry1:any) =>{
                        // find the corresponding property using source and kpi
                        // first check if we have added this to myData
                        // find matching kpi, source, and location
                        matchingData = myData.find(item => item.du_sp_location_key === entry1.sp_location_key && entry1.kpi_key === item.kpi_key && entry1.x_axis_value === item.x_axis_value);
                        if(matchingData){
                          // now just add to periods
                          matchingData.periods.push({
                                period: entry1.period,
                                kpi_value: entry1.kpi_value
                            });
                        }
                        else{
                          // not in myData so get the props, initialize periods and add to myData
                          singleProp = myProps.find(prop =>
                            prop.y_axis_key == entry1.y_axis_key && prop.x_axis_key === entry1.x_axis_key
                          )
                          if (singleProp){
                            // Add location name if available                           
                            const newEntry = {
                              ...singleProp,
                              du_sp_location_name: entry1.sp_location_name,
                              du_sp_location_key: entry1.sp_location_key,
                              kpi_key: entry1.kpi_key,
                              periods: [{
                                period: entry1.period,
                                kpi_value: entry1.kpi_value
                              }],
                              x_axis_value: entry1.x_axis_value
                            };
                            // Take KPI name from PROP, instead of Data point
                            // newEntry.kpi_nm = entry1.kpi_nm
                            newEntry.kpi_nm = singleProp.kpi_nm
                            myData.push(newEntry);
                          }
                        }
                      });
                      console.log(myData);
                      this.isDataLoaded = true;
                      this.data = myData == null ? [] : myData;
                      this.error_name = '';
                    },(err:any)=>{
                      this.data = [];
                      this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
                    })
                  )
            //     },
            //     (error: any) => {
            //       this.data = [];
            //     }
            //   )
            // );
            this.error_name = '';
          },(err:any)=>{
            this.data = [];
            this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
          }));            
    }
  }
  
  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

  getgridData(value: number){
    console.log(value);
  }

  // Given a date, go back a certain amount of time cycles based on amount
  goBackCycles(dateStr: string, amount: number, cycle: 'W' | 'M' | 'Q' | 'Y'): string {
  const date = new Date(dateStr);
  switch (cycle) {
      case 'W':
          date.setDate(date.getDate() - (amount * 7));
          break;
      case 'M':
          date.setMonth(date.getMonth() - amount);
          break;
      case 'Q':
          date.setMonth(date.getMonth() - (amount * 3));
          break;
      case 'Y':
          date.setFullYear(date.getFullYear() - amount);
          break;
      default:
          throw new Error("Invalid cycle type. Use 'week', 'month', 'quarter', or 'year'.");
  }
  
  return date.toISOString().split('T')[0]; // Return as YYYY-MM-DD
  }
     getPreferences() {
    if(this.item?.widget_uniq_key) {
      let obj = {
        dashboard_key: this.dashboardKey,
        page_name:this.item.config["report_heading"],
        page_key: this.pageKey,
        widget_uinique_key: this.item?.widget_uniq_key,
        employee_key: this.filterService.baseQuery?.employee_key || 0
      }
      this.dataService.getPreference(obj).subscribe((res:any) => {
        if(res && res.length) {
          let value = res?.[0]?.preference_value ? JSON.parse(res?.[0]?.preference_value) : '';
          this.prefrenceConfig = value;
        }
      })
    }
  }
}
